// extracted by mini-css-extract-plugin
module.exports = {"navBox":"navBox___3FKkr","search":"search___22FsX","searchBox":"searchBox___z30N7","icon":"icon___v25uC","giftBox":"giftBox___3-O3I","Box":"Box___1ymAH"};